import { creatRestClient, getHeaders, type Logger } from '@seek/libs-shared';

import type { AppConfig } from '../../config';

import type { LegacyCompanyProfile } from './types';

export interface LegacyCompanyProfileServiceOptions {
  companyProfilesApiBaseUrl: string;
  config: AppConfig;
  logger: Logger;
}

export const createLegacyCompanyProfileService = ({
  companyProfilesApiBaseUrl,
  config,
  logger,
}: LegacyCompanyProfileServiceOptions) => {
  const commonHeaders = getHeaders(config, false)();
  // omit 'x-real-ip' header from headers
  delete commonHeaders['x-real-ip'];

  const { get } = creatRestClient(companyProfilesApiBaseUrl, logger, {
    ...commonHeaders,

    'x-country-iso': config.country,
  });

  const getLegacyCompanyProfilePreview = async (companyId: string) => {
    try {
      const response = await get<LegacyCompanyProfile>(
        `/companies/${companyId}/profile/preview`,
      );

      return response?.data;
    } catch (error) {
      logger.error(
        { error, companyId },
        'Error calling getLegacyCompanyProfilePreview',
      );
      return undefined;
    }
  };

  const getCompanyProfileForeignId = async (
    companyId: string,
  ): Promise<string | undefined> => {
    const response = await get<LegacyCompanyProfile>(
      `/companies/${companyId}/profile`,
    );

    return response?.data?.foreign_company_id;
  };

  return {
    getCompanyProfileForeignId,
    getLegacyCompanyProfilePreview,
  };
};
